import { Dropdown, DropdownButton } from "./components/ui/dropdown";
import {
  Navbar,
  NavbarDivider,
  NavbarSection,
  NavbarSpacer,
} from "./components/ui/navbar";
import {
  Sidebar,
  SidebarBody,
  SidebarHeader,
  SidebarItem,
  SidebarLabel,
  SidebarSection,
} from "./components/ui/sidebar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./components/ui/dropdown-menu";
import logo from "./assets/logo.png";
import { StackedLayout } from "./components/ui/stacked-layout";
import { ChevronDownIcon } from "@heroicons/react/16/solid";
import { Text } from "./components/ui/text";
import { Menu } from "@base-ui-components/react/menu";
import { Link } from "react-router";
import { useEffect, useState } from "react";
import { useAuth } from "./context/AuthContext";
import { Avatar } from "antd";
import { User } from "lucide-react";
import * as Sentry from "@sentry/react";
const { logger } = Sentry;

const adminNavItems = [
  {
    label: "Home",
    url: "/",
    menuList: [{ label: "Settings", url: "/admin/settings" }],
  },
  {
    label: "Reports",
    menuList: [
      {
        label: "Interpreters Report",
        url: "/admin",
      },
    ],
  },
  {
    label: "Interpreters",
    menuList: [
      {
        label: "All Interpreters",
        url: "/admin/interpreters",
      },
    ],
  },
  {
    label: "Customers",
    menuList: [
      {
        label: "All Customers",
        url: "/admin/customers",
      },
      {
        label: "Add Customer",
        url: "/admin/customers/add",
      },
    ],
  },
  {
    label: "Agents",
    menuList: [{ label: "All Agents", url: "/admin/agents" }],
  },
  // { label: "Settings", url: "/settings" },
];
const agentNavItems = [];
const customersNavItems = [];
const interpreterNavItems = [];
const supervisorNavItems = [
  {
    label: "Reports",
    menuList: [
      {
        label: "Interpreters Report",
        url: "/admin",
      },
    ],
  },
  {
    label: "Interpreters",
    menuList: [
      {
        label: "All Interpreters",
        url: "/admin/interpreters",
      },
    ],
  },

  {
    label: "Agents",
    menuList: [{ label: "All Agents", url: "/admin/agents" }],
  },
];

function ArrowSvg(props) {
  return (
    <svg width="20" height="10" viewBox="0 0 20 10" fill="none" {...props}>
      <path
        d="M9.66437 2.60207L4.80758 6.97318C4.07308 7.63423 3.11989 8 2.13172 8H0V10H20V8H18.5349C17.5468 8 16.5936 7.63423 15.8591 6.97318L11.0023 2.60207C10.622 2.2598 10.0447 2.25979 9.66437 2.60207Z"
        className="fill-[canvas]"
      />
      <path
        d="M8.99542 1.85876C9.75604 1.17425 10.9106 1.17422 11.6713 1.85878L16.5281 6.22989C17.0789 6.72568 17.7938 7.00001 18.5349 7.00001L15.89 7L11.0023 2.60207C10.622 2.2598 10.0447 2.2598 9.66436 2.60207L4.77734 7L2.13171 7.00001C2.87284 7.00001 3.58774 6.72568 4.13861 6.22989L8.99542 1.85876Z"
        className="fill-gray-200"
      />
      <path
        d="M10.3333 3.34539L5.47654 7.71648C4.55842 8.54279 3.36693 9 2.13172 9H0V8H2.13172C3.11989 8 4.07308 7.63423 4.80758 6.97318L9.66437 2.60207C10.0447 2.25979 10.622 2.2598 11.0023 2.60207L15.8591 6.97318C16.5936 7.63423 17.5468 8 18.5349 8H20V9H18.5349C17.2998 9 16.1083 8.54278 15.1901 7.71648L10.3333 3.34539Z"
        className=""
      />
    </svg>
  );
}

export default function Dashboard({ children }) {
  const { logout, user } = useAuth();
  const [navItems, setNavItems] = useState([]);

  useEffect(() => {
    if (user && user.user_type) {
      logger.info(window.navigator.userAgent);
      logger.info(navigator.userAgent);
      if (user.user_type === "admin") {
        if (window.navigator.userAgent.includes("ZoomApps")) {
          setNavItems(agentNavItems);
        } else {
          setNavItems(adminNavItems);
        }
      } else if (user.user_type === "customer") {
        setNavItems(customersNavItems);
      } else if (user.user_type === "interpreter") {
        setNavItems(interpreterNavItems);
      } else if (user.user_type === "agent") {
        setNavItems(agentNavItems);
      } else if (user.user_type === "supervisor") {
        if (window.navigator.userAgent.includes("ZoomApps")) {
          setNavItems(agentNavItems);
        } else {
          setNavItems(supervisorNavItems);
        }
      }
    }
  }, [user]);

  return (
    <StackedLayout
      navbar={
        <Navbar>
          <img src={logo} width={200} alt="911 Interpreters Logo" />
          <Text className="capitalize !text-gray-600 font-light text-sm">
            {window.navigator.userAgent.includes("ZoomApps") &&
            user?.user_type != "interpreter"
              ? "Operator"
              : !window.navigator.userAgent.includes("ZoomApps") &&
                user?.user_type != "interpreter"
              ? user?.user_type
              : "Interpreter"}{" "}
            Panel
          </Text>

          {navItems.length > 0 && <NavbarDivider className="" />}
          <NavbarSection className=" flex gap-5">
            {navItems.map(({ label, menuList }) => (
              <Menu.Root>
                <Menu.Trigger
                  disabled={menuList.length == 0}
                  className="flex items-center justify-center rounded-md font-medium text-sm outline-none cursor-pointer"
                >
                  {label}{" "}
                  {menuList.length > 0 && (
                    <ChevronDownIcon className="ml-1 w-3" />
                  )}
                </Menu.Trigger>
                <Menu.Portal>
                  <Menu.Positioner className="outline-none" sideOffset={8}>
                    <Menu.Popup className="origin-[var(--transform-origin)] rounded-md bg-[canvas] py-1 text-gray-900 shadow-lg shadow-gray-200 outline outline-gray-200 transition-[transform,scale,opacity] data-[ending-style]:scale-90 data-[ending-style]:opacity-0 data-[starting-style]:scale-90 data-[starting-style]:opacity-0">
                      <Menu.Arrow className="data-[side=bottom]:top-[-8px] data-[side=left]:right-[-13px] data-[side=left]:rotate-90 data-[side=right]:left-[-13px] data-[side=right]:-rotate-90 data-[side=top]:bottom-[-8px] data-[side=top]:rotate-180">
                        <ArrowSvg />
                      </Menu.Arrow>
                      {menuList.map(({ label, url }) => (
                        <Menu.Item
                          render={<Link to={url}>{label}</Link>}
                          className="flex cursor-default py-2 pr-8 pl-4 text-sm leading-4 outline-none select-none data-[highlighted]:relative data-[highlighted]:z-0 data-[highlighted]:text-gray-50 data-[highlighted]:before:absolute data-[highlighted]:before:inset-x-1 data-[highlighted]:before:inset-y-0 data-[highlighted]:before:z-[-1] data-[highlighted]:before:rounded-sm data-[highlighted]:before:bg-gray-900"
                        ></Menu.Item>
                      ))}
                    </Menu.Popup>
                  </Menu.Positioner>
                </Menu.Portal>
              </Menu.Root>
            ))}
          </NavbarSection>
          <NavbarSpacer />
          {user.user_type != "interpreter" &&
            (user.user_type == "admin" ||
              !window.navigator.userAgent.includes("ZoomApps")) && (
              <NavbarSection>
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <div className="bg-transparent rounded-full p-1 cursor-pointer hover:bg-gray-50">
                      <Avatar size="small" icon={<User />} />
                    </div>
                  </DropdownMenuTrigger>
                  <button onClick={logout}>
                    <DropdownMenuContent className="w-56 mr-2">
                      <DropdownMenuItem
                        className={
                          "text-red-500 font-semibold hover:text-red-500"
                        }
                      >
                        Log out
                      </DropdownMenuItem>
                    </DropdownMenuContent>
                  </button>
                </DropdownMenu>
              </NavbarSection>
            )}
        </Navbar>
      }
      sidebar={
        <Sidebar>
          <SidebarHeader>
            <Dropdown>
              <DropdownButton as={SidebarItem} className="lg:mb-2.5">
                {/* <Avatar src="/tailwind-logo.svg" /> */}
                <SidebarLabel>911 Interpreters</SidebarLabel>
                <ChevronDownIcon />
              </DropdownButton>
            </Dropdown>
          </SidebarHeader>
          <SidebarBody>
            <SidebarSection>
              {navItems.map(({ label, menuList }) => (
                <Menu.Root>
                  <Menu.Trigger
                    disabled={menuList.length == 0}
                    className="flex items-center justify-center rounded-md font-medium text-sm outline-none cursor-pointer"
                  >
                    {label}{" "}
                    {menuList.length > 0 && (
                      <ChevronDownIcon className="ml-1 w-3" />
                    )}
                  </Menu.Trigger>
                  <Menu.Portal>
                    <Menu.Positioner className="outline-none" sideOffset={8}>
                      <Menu.Popup className="origin-[var(--transform-origin)] rounded-md bg-[canvas] py-1 text-gray-900 shadow-lg shadow-gray-200 outline outline-gray-200 transition-[transform,scale,opacity] data-[ending-style]:scale-90 data-[ending-style]:opacity-0 data-[starting-style]:scale-90 data-[starting-style]:opacity-0 ">
                        <Menu.Arrow className="data-[side=bottom]:top-[-8px] data-[side=left]:right-[-13px] data-[side=left]:rotate-90 data-[side=right]:left-[-13px] data-[side=right]:-rotate-90 data-[side=top]:bottom-[-8px] data-[side=top]:rotate-180">
                          <ArrowSvg />
                        </Menu.Arrow>
                        {menuList.map(({ label, url }) => (
                          <Menu.Item
                            render={<Link to={url}>{label}</Link>}
                            className="flex cursor-default py-2 pr-8 pl-4 text-sm leading-4 outline-none select-none data-[highlighted]:relative data-[highlighted]:z-0 data-[highlighted]:text-gray-50 data-[highlighted]:before:absolute data-[highlighted]:before:inset-x-1 data-[highlighted]:before:inset-y-0 data-[highlighted]:before:z-[-1] data-[highlighted]:before:rounded-sm data-[highlighted]:before:bg-gray-900"
                          ></Menu.Item>
                        ))}
                      </Menu.Popup>
                    </Menu.Positioner>
                  </Menu.Portal>
                </Menu.Root>
              ))}
            </SidebarSection>
          </SidebarBody>
        </Sidebar>
      }
    >
      {children}
    </StackedLayout>
  );
}
